import React from 'react';
import { Image, StyleSheet } from 'react-native';

interface BillCharacterSVGProps {
  width?: number;
  height?: number;
}

export const BillCharacterSVG: React.FC<BillCharacterSVGProps> = ({ 
  width = 48, 
  height = 53 
}) => {
  return (
    <Image 
      source={require('../assets/images/bill.png')} 
      style={[styles.billImage, { width, height }]}
      resizeMode="contain"
    />
  );
};

const styles = StyleSheet.create({
  billImage: {
    borderRadius: 24,
  },
});

export default BillCharacterSVG;